import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";

export const selectorCardName = (card: cardApiSpec.Card) =>
  card.isVirtualCard ? "virtual card" : "physical debit card";
